
























































































import {Component, Ref, Vue} from 'vue-property-decorator';
import {MessageCategoryItem, MessageCategoryItemImpl} from '@/store/settings/message_categories/types';
import {InputWings, SelectWings, TextareaWings} from 'wings-ui-components';
import {Action, Getter} from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import {notifyError, notifyDelete, notifyConfirm, notifyErrorCustom} from '@/utils/notify-helper';
import draggable from 'vuedraggable'
import i18n from "@/plugins/i18n";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, draggable, InputWings, TextareaWings}})
export default class MessageCategory extends Vue {

  @Ref('validator') validator: any;

  @Action("getMessageCategoryItem") actionGetItem: any;
  @Action("saveMessageCategoryItem") actionSaveItem: any;
  @Action("deleteMessageCategoryItem") actionDeleteItem: any;
  @Action("actionLog") actionLog: any;

  @Getter("transports") transportsList: any;
  @Getter("allowedTransports") allowedTransportsList: any;

  private logObject: ActionLog = {};
  item = this.defaultItem();
  itemSaved = this.defaultItem();

  clonedArray: any = {
    name: '',
    description: '',
    transports: []
  };

  defaultItem(): MessageCategoryItem {
    return new MessageCategoryItemImpl();
  }

  async created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message category",
        addititional_info: getTranslatedParams({id: this.$route.params.id}),
      }
      this.actionGetItem(this.$route.params.id)
          .then((data: MessageCategoryItem) => {
            this.item = Object.assign({}, this.item, data);
            this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
            this.actionLog(this.logObject);
            this.clonedArray = cloneDeep(Object.assign({}, this.item, data));
            let arr: any = [];
            this.item.transports.forEach((elem: any) => arr.push(elem.transport_id));
            let includesTransport: any = this.allowedTransportsList.filter((x: any) => !arr.includes(x))
            this.addEmptyItem(this.clonedArray, includesTransport)
            this.addEmptyItem(this.item, includesTransport)
          })
          .catch((error: any) => {
            this.actionLog({...this.logObject, action_status: "failed"});
            notifyError(error);
            this.back();
          });
    } else {
      this.addEmptyItem(this.clonedArray,this.allowedTransportsList);
      this.item = cloneDeep(Object.assign({}, this.item, this.clonedArray));
    }
  }

  addEmptyItem(toArrAdd:any,transports:any){
    for (let i = 0; i < transports.length; i++) {
      toArrAdd.transports.push(
          {
            'transport_id': transports[i],
            'is_default': 0,
            'is_involved': 0,
          }
      );
    }
  }

  back(): void {
    this.$router.push('/settings/message_categories/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        if (this.checkToEmptyTransport(this.item.transports)) {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Message category",
            addititional_info: getTranslatedParams(this.item),
          }
          if (!this.checkToDefaultCategory()) {
            try {
              await this.actionSaveItem(this.item);
              await this.actionLog(this.logObject);
              this.itemSaved = this.item;
              this.clonedArray = this.item;
              resolve();
              this.back();
            } catch (error) {
              this.actionLog({...this.logObject, action_status: "failed"});
              reject()
              notifyError(error);
            }
            } else {
            let isConfirm: boolean = await notifyDelete(i18n.tc('dialog.delete_all_default_category'));
            if (isConfirm) {
              try {
                await this.actionSaveItem(this.item);
                await this.actionLog(this.logObject);
                this.itemSaved = this.item;
                this.clonedArray = this.item;
                resolve()
                this.back();
              } catch (error) {
                this.actionLog({...this.logObject, action_status: "failed"});
                reject();
                notifyError(error);
              }
            } else return
          }
        } else {
          notifyErrorCustom(i18n.tc('dialog.not_selected_transport'));
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  onDeleteItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let isConfirm: boolean = await notifyDelete(i18n.tc('dialog.delete_all_tarifzone'));
      if (isConfirm) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Removal",
            action_status: "success",
            object_type: "Message category",
            addititional_info: getTranslatedParams(this.item),
          }
          await this.actionDeleteItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          this.clonedArray = this.item;
          resolve();
          this.back();
        } catch (error) {
          this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      }
    });
  }

  getTransportName(transport_id: any): any {
    if (this.transportsList) {
      return this.transportsList.find((t: any) => t.id === transport_id)?.name;
    }
  }

  checkToEmptyTransport(transports: any): boolean {
    return transports.some((transport: any) => transport.is_default === 1) || transports.some((transport: any) => transport.is_involved === 1)
  }

  checkToDefaultCategory() {
    if (this.$route.params.id) {
      let bool:any=[];
      let check = this.item.transports.some((elem: any, index: number) => {
        if (elem.is_default == this.clonedArray.transports[index].is_default) {
          bool.push(true);
        } else {
          elem.is_default == 0 ? bool.push(true) : bool.push(false)
        }
      });
      let isChange: boolean = bool.some((elem: boolean) => {
       return elem === false
      })
        return isChange;
    } else {
      return false
    }
  }


  checkToDefaultTransport(index: number) {
    if (this.item.transports[index].is_involved == 0){
      this.item.transports[index].is_default = 0;
      return true;
    } else {
      return false
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.clonedArray);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

};
